import Loading from '@rahtab/stack-navigator/src/Loading';
import { Picker } from '@rahtab/ui';
import useGetProvincesInfo from 'hooks/useGetProvincesInfo';
import React, { useState } from 'react';

interface ProvincePickerProps {
  selected?: string;
  onSelectValue?: (province: string) => void;
}

const ProvincePicker: React.VFC<ProvincePickerProps> = (props) => {
  const { selected = '', onSelectValue } = props;
  const [province, setProvince] = useState(selected);
  const { data, loading } = useGetProvincesInfo();

  const renderPickerItems = () => {
    if (!data) return [];
    return data.Provinces.map(({ ProvinceName }) => (
      <Picker.Item key={ProvinceName} label={ProvinceName} value={ProvinceName} />
    ));
  };

  const handleOnSelectValue = (value: string) => {
    setProvince(value);
    onSelectValue?.(value);
  };

  return (
    <Picker
      label="استان مرغدار"
      placeholder="استان واحد مرغداری ارسال کننده را انتخاب نمایید."
      contentHeader={loading ? <Loading /> : <></>}
      selectedValue={province}
      onSelectValue={handleOnSelectValue}>
      {renderPickerItems()}
    </Picker>
  );
};

export default ProvincePicker;
